<template>
  <div>
   <!-- <headlink></headlink>-->
    <headlink v-if="parent == '0'"></headlink>
    <headlink1 v-if="parent == '1'"></headlink1>
    <div class="container ui-flex ui-flex-pack-center">
      <div class="input-container padding-top-100 ui-center" >
        <div style="width: 65%;" >
          <input v-model="uuid" class="input-big input" placeholder="请输入UID码"/>
        <!--  <div class="error" style="text-align: center" >{{error}}</div>-->
        </div>
        <div class="padding-top-100">
          <button class="button-sure "  v-on:click="addDevice()" >
            添加设备
          </button>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
 import headlink from '@/components/common/headlink'
	import headlink1 from '@/components/common/headlink1'
	import devicemanage1 from '@/components/devicemanage/devicemanage1'
	import devicemanage2 from '@/components/devicemanage/devicemanage2'

  export default {
    name: 'addDevice',
    data () {
      return {
        uuid:"",
        error:"",
        parent: "0"
      }
    },
    mounted: function () {
    	const history = window.sessionStorage;
			var uid = history.getItem("user");
			var parent = history.getItem("parent");
			this.parent = parent;
    	
    	
    	
    },
    methods:{
      addDevice:function(){
        var self = this;
        if(this.uuid==''){
          jeBox.msg('请输入uid码！', {icon: 3,time:1});
       //  self.error = "请输入uid码";
          return ;
        }
        const history = window.sessionStorage;
        var uid = history.getItem("user");
        this.$http.post('/ZYun/HttpService.do', {
          "serviceCode":"1009",
          "uId":uid,
          "eqId":this.uuid
        })
          .then((response) => {
            if(response.data.respCode=="0000"){
             jeBox.msg('添加成功！', {icon: 2,time:1});
            }else{
             jeBox.msg('添加失败！', {icon: 3,time:1});
            }
          })
          .catch((response) =>{
            console.log(response);
          });
      }
    },
    components: {
      headlink: headlink,
			headlink1: headlink1,
			devicemanage1: devicemanage1,
			devicemanage2: devicemanage2
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css">

</style>



// WEBPACK FOOTER //
// src/components/addDevice/addDevice.vue